<section class="flex flex-col gap-8">
  <div class="flex max-w-[800px] flex-col gap-5">
    <h4 class="text-3xl">Do Work That Has An Impact</h4>
    <span class="text-lg text-secondary-foreground"
    >We’re redefining technology. No matter how long it takes, we’ll ensure that everyone has an equal opportunity to innovation; one
      website, one application at a time.</span
    >
  </div>

  <div class="flex flex-col">
    @if (!loading()) {
      @for (item of openPositions(); track item; let last = $last) {
        <div class="mb-8 flex flex-col gap-8 border-b border-gray-200 pb-8 lg:flex-row"
             [ngClass]="{ 'mb-0 border-b-0 pb-0': last }">
          <div class="w-full lg:w-96">
            <app-info-card
              [showButton]="true"
              [title]="item.title"
              [highlightTitle]="item.highlight"
              [description]="item.description"
              (buttonClick)="redirectToEmail(item.title)"
              buttonText="Apply Now"
              sectionClassName="bg-gray-100"
              titleClassName="text-2xl"
              highlightTitleClassName="text-secondary-foreground text-lg border-b border-gray-200 pb-4 mb-4 w-full"
              descriptionClassName="text-secondary-foreground w-full"/>
          </div>

          <div class="flex flex-1 flex-col gap-4">
            @for (position of item.positions; track position) {
              <app-compound-card
                [title]="position.title"
                [description]="position.description"
                sectionClassName="bg-gray-100 gap-4"
                [showHeaderButtonRight]="true"
                (headerButtonClick)="goToJob(position)"
                buttonText="View Job"
                buttonIcon="arrow-up-right"
                btnVariant="contrast"
                titleClassName="text-xl"
                descriptionClassName="text-lg"
                [headerBadges]="position.headerBadges"
                [footerBadges]="position.footerBadges"/>
            }
          </div>
        </div>
      }
    } @else {
      @for (mock of [1, 2]; track mock) {
        <div class="mb-8 flex flex-col gap-8 pb-8 lg:flex-row">
          <div class="w-full lg:w-96">
            <hlm-skeleton class="h-[400px] w-full"/>
          </div>

          <div class="flex flex-1 flex-col gap-4">
            @for (mock of [1, 2]; track mock) {
              <hlm-skeleton class="h-[300px] w-full"/>
            }
          </div>
        </div>
      }
    }
  </div>

  <div class="-mt-16 flex w-full items-center justify-center rounded-2xl border-gray-200 bg-gray-50">
    <img ngSrc="assets/media/images/careers-img1.svg" alt="careers" width="859" height="520" priority
         class="max-h-[520px] w-full"/>
  </div>
</section>
